import Head from "next/head";
import Layout from "../components/Layout";
import HomePage from "../components/pages/HomePage";

export default function Home() {
  return (
    <Layout pageName="Home">
      <Head>
        <title>Skuldpaus.se</title>
      </Head>
      <HomePage />
    </Layout>
  );
}
